<template>
    <div class="image-wrapper" :class="{'image-loaded': loaded, 'has-img-not-found': hasErrors}">
        <img
                :src="srcImage"
                v-if="!hasErrors"
                @load="imageLoaded(true)"
                @error="imageLoaded(false)"
        />
        <div v-if=hasErrors class="img-not-found"></div>
        <font-awesome-icon icon="spinner" v-if="!loaded && !hasErrors" spin/>
    </div>
</template>

<script>
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSpinner} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

library.add(faSpinner)

export default {
  props: ['src'],
  components: {
    FontAwesomeIcon
  },
  data: () => ({
    observer: null,
    intersected: false,
    loaded: false,
    destroyImg: false,
    hasErrors: false
  }),
  computed: {
    srcImage () {
      return this.destroyImg ? null : (this.intersected ? this.src : null)
    }
  },
  mounted () {
    this.observer = new IntersectionObserver(entries => {
      const image = entries[0]
      if (image.isIntersecting) {
        this.intersected = true
        this.observer.disconnect()
      }
    })

    this.observer.observe(this.$el)
  },
  beforeDestroy () {
    this.destroyImg = true
  },
  destroyed () {
    this.observer.disconnect()
  },
  methods: {
    imageLoaded (status) {
      let vm = this
      vm.loaded = true
      if (!status) {
        vm.hasErrors = true
      }
      this.$emit('imageLoaded', status)
    }
  }
}
</script>
<style scoped>
    .image-wrapper {
        text-align: center;
        color: #fff;
        height: 100%;
        align-items: center;
    }

    .image-wrapper .img-not-found {
        width: 240px;
        height: 100%;
    }

    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -.5rem;
        margin-top: -.5rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/LazyImage.vue